import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const ReturnedReport = lazy(() =>
  import("../../components/report/returnedReport")
);

const ReturnedReportPage = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <ReturnedReport />
    </Suspense>
  );
};

export default ReturnedReportPage;
